import baseV3Service from './base/baseV3Service.js';

const getRoles = (config) => {
    return baseV3Service.get("roles", config);
};
const getUsers = (config) => {
    return baseV3Service.get("users", config);
};
const getUser = (userId, config) => {
    return baseV3Service.get(`users/${userId}`, config);
};
const updateUser = (_id, payload, config) => {
    return baseV3Service.put(`users/${_id}`, payload, config);
};
const createUser = (payload, config) => {
    return baseV3Service.post("users", payload, config);
};
const deleteUser = (userId, config) => {
    return baseV3Service.delete(`users/${userId}`, config);
};

export { createUser, deleteUser, getRoles, getUser, getUsers, updateUser };
